(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bc-home-editorial"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (scope) => {
    scope.querySelectorAll('[data-bc-home]').forEach((root) => {
      if (root.dataset.bcReady) return;
      root.dataset.bcReady = 'true';
      root.querySelectorAll('.bc-home-product-image-secondary').forEach((image) => {
        const showWhenLoaded = () => {
          if (image.naturalWidth > 0) image.parentElement.classList.add('is-secondary-ready');
        };
        if (image.complete) showWhenLoaded();
        else image.addEventListener('load', showWhenLoaded, { once: true });
      });
      const buttons = root.querySelectorAll('[data-bc-show]');
      const slides = root.querySelectorAll('[data-bc-slide]');
      const controls = root.querySelector('.bc-home-hero-controls');
      if (controls) controls.hidden = false;
      buttons.forEach((button) => button.addEventListener('click', () => {
        const selected = Number(button.dataset.bcShow);
        slides.forEach((slide, index) => { slide.hidden = index !== selected; });
        buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      }));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc-product-suggestions"]) return;
  try {
    
  if (!customElements.get('bc-product-suggestions')) {
    customElements.define('bc-product-suggestions', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded || this.observer) return;
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.observer.disconnect();
            this.load();
          }
        }, { rootMargin: '0px 0px 400px 0px' });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.controller) this.controller.abort();
        this.observer = null;
      }
      async load() {
        this.controller = new AbortController();
        try {
          const url = new URL(this.dataset.url, window.location.origin);
          const previewTheme = new URLSearchParams(window.location.search).get('preview_theme_id');
          if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
          const response = await fetch(url, { signal: this.controller.signal });
          if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const content = html.querySelector('bc-product-suggestions[data-intent="' + this.dataset.intent + '"] .bc-suggestions__content');
          if (content && this.isConnected) this.replaceChildren(content);
          this.dataset.loaded = 'true';
        } catch (error) {
          if (error.name !== 'AbortError') this.dataset.loaded = 'error';
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc-warm-cart"]) return;
  try {
    
  (() => {
    const form = document.getElementById('BCCartForm');
    if (!form || form.dataset.bcReady) return;
    form.dataset.bcReady = 'true';
    const documentType = form.querySelector('#BCDocument');
    form.addEventListener('invalid', event => { const disclosure = event.target.closest('details'); if (disclosure) disclosure.open = true; }, true);
    const invoiceFields = form.querySelector('#BCInvoiceFields');
    const invoiceInputs = Array.from(form.querySelectorAll('[data-invoice-field]'));
    function syncInvoice() {
      const invoice = documentType.value === 'Τιμολόγιο';
      invoiceFields.hidden = !invoice;
      invoiceInputs.forEach(input => {
        input.required = invoice;
        input.disabled = !invoice;
        let clear = form.querySelector('[data-clear-invoice="' + input.id + '"]');
        if (!clear) {
          clear = document.createElement('input');
          clear.type = 'hidden';
          clear.name = input.name;
          clear.dataset.clearInvoice = input.id;
          clear.value = '';
          form.appendChild(clear);
        }
        clear.disabled = invoice;
      });
    }
    documentType.addEventListener('change', syncInvoice);
    syncInvoice();
    const agree = form.querySelector('#CartPageAgree');
    const error = form.querySelector('#BCTermsError');
    const express = form.querySelector('#BCExpress');
    const checkout = form.querySelector('[name="checkout"]');
    const update = form.querySelector('#BCUpdate');
    const dock = form.querySelector('#BCMobileDock');
    const dockCheckout = form.querySelector('#BCDockCheckout');
    dock.hidden = false;
    dockCheckout.addEventListener('click', () => {
      if (!agree.checked) { showTermsError(); agree.scrollIntoView({ block: 'center', behavior: 'smooth' }); return; }
      form.requestSubmit(checkout);
    });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => { dock.hidden = entries[0].isIntersecting; }, { threshold: 0.2 });
      observer.observe(checkout);
    }
    function showTermsError() {
      error.hidden = false;
      agree.setAttribute('aria-invalid', 'true');
      agree.focus();
    }
    agree.checked = false;
    function syncTerms() {
      error.hidden = true;
      agree.removeAttribute('aria-invalid');
      if (express) { express.hidden = !agree.checked; express.inert = !agree.checked; }
    }
    syncTerms();
    agree.addEventListener('change', syncTerms);
    agree.addEventListener('invalid', event => { event.preventDefault(); showTermsError(); });
    checkout.addEventListener('click', event => { if (!agree.checked) { event.preventDefault(); showTermsError(); } });
    form.addEventListener('submit', event => {
      if (event.submitter === update) return;
      if (!agree.checked) { event.preventDefault(); showTermsError(); }
    });
    form.querySelectorAll('[data-bc-step]').forEach(button => {
      button.addEventListener('click', () => {
        const input = button.parentElement.querySelector('input');
        input.value = Math.max(0, (parseInt(input.value, 10) || 0) + Number(button.dataset.bcStep));
        form.requestSubmit(update);
      });
    });
    form.querySelectorAll('input[name="updates[]"]').forEach(input => {
      input.addEventListener('change', () => {
        if (!input.checkValidity() || input.value === '') { input.reportValidity(); return; }
        form.requestSubmit(update);
      });
    });
    window.addEventListener('pageshow', () => { agree.checked = false; syncInvoice(); syncTerms(); });
  })();

  } catch(e) { console.error(e); }
})();
})();
